export const PER_PAGE_UNPAGINATED = 10000;

export const DEFAULT_PAGE = 1;
